import { render, staticRenderFns } from "./standings.vue?vue&type=template&id=778f22ee&"
import script from "./standings.vue?vue&type=script&lang=js&"
export * from "./standings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports